import { Component, Input } from '@angular/core'

type TSkeletonWidth = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'full'

@Component({
    selector: 'app-skeleton-header',
    templateUrl: './skeleton-header.component.html',
    styleUrls: ['./skeleton-header.component.scss'],
})
export class SkeletonHeaderComponent {
    @Input() showBack = true
    @Input() titleWidth: TSkeletonWidth = 'xl'
    @Input() orderIdWidth: TSkeletonWidth = 's'
    @Input() actionCount = 2
    @Input() badgeCount = 3
    @Input() amountWidth: TSkeletonWidth = 'xl'

    get actions(): number[] {
        return Array(this.actionCount).fill(0)
    }
    get badges(): number[] {
        return Array(this.badgeCount).fill(0)
    }
}
